export const FARO_APP_NAME = 'assban-certifica-exames';
export const FARO_COLLECT_URL = 'https://rum.funifier.com/collect';

const DEFAULT_VERSION = '0.0.0';

export type FaroEnvironment = 'production' | 'development';

export interface ObservabilityEnv {
  REACT_APP_FARO_API_KEY?: string;
  REACT_APP_FARO_TRACE_PROPAGATION_URLS?: string;
  REACT_APP_DEPLOY_CONTEXT?: string;
  REACT_APP_VERSION?: string;
}

export interface FaroConfig {
  apiKey: string;
  version: string;
  environment: FaroEnvironment;
  propagationUrls: RegExp[];
}

export const resolveEnvironment = (deployContext?: string): FaroEnvironment =>
  deployContext === 'production' ? 'production' : 'development';

const escapeRegExp = (value: string) =>
  value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const toOrigin = (rawUrl: string): string | null => {
  try {
    const { protocol, origin } = new URL(rawUrl);
    return protocol === 'http:' || protocol === 'https:' ? origin : null;
  } catch {
    return null;
  }
};

export const parsePropagationUrls = (raw?: string): RegExp[] =>
  (raw ?? '')
    .split(',')
    .map(item => toOrigin(item.trim()))
    .filter((origin): origin is string => origin !== null)
    .map(origin => new RegExp(`^${escapeRegExp(origin)}(/|$)`));

export const buildFaroConfig = (env: ObservabilityEnv): FaroConfig | null => {
  const apiKey = env.REACT_APP_FARO_API_KEY;
  if (!apiKey) return null;

  return {
    apiKey,
    version: env.REACT_APP_VERSION || DEFAULT_VERSION,
    environment: resolveEnvironment(env.REACT_APP_DEPLOY_CONTEXT),
    propagationUrls: parsePropagationUrls(
      env.REACT_APP_FARO_TRACE_PROPAGATION_URLS,
    ),
  };
};
